import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconDocument({ className }: IconProps): ReactElement {
    return (
        <svg className={className} xmlns='http://www.w3.org/2000/svg'>
            <g fillRule='evenodd'>
                <g id='ic_document' transform='translate(-3.000000, -2.000000)' fillRule='nonzero'>
                    <g id='save'>
                        <g transform='translate(4.000000, 3.000000)'>
                            <path
                                d='M1,1 L1,18 L15,18 L15,5.41421356 L10.5857864,1 L1,1 Z M0,-1 L11,-1 C11.2652165,-1 11.5195704,-0.89464316 11.7071068,-0.707106781 L16.7071068,4.29289322 C16.8946432,4.4804296 17,4.73478351 17,5 L17,19 C17,19.5522847 16.5522847,20 16,20 L0,20 C-0.55228475,20 -1,19.5522847 -1,19 L-1,0 C-1,-0.55228475 -0.55228475,-1 0,-1 Z'
                                id='Rectangle-6'
                            />
                            <path
                                d='M4,8 L12,8 C12.5522847,8 13,7.55228475 13,7 C13,6.44771525 12.5522847,6 12,6 L4,6 C3.44771525,6 3,6.44771525 3,7 C3,7.55228475 3.44771525,8 4,8 Z'
                                id='Line'
                            />
                            <path
                                d='M4,12 L12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 L4,10 C3.44771525,10 3,10.4477153 3,11 C3,11.5522847 3.44771525,12 4,12 Z'
                                id='Line'
                            />
                            <path
                                d='M4,16 L6,16 C6.55228475,16 7,15.5522847 7,15 C7,14.4477153 6.55228475,14 6,14 L4,14 C3.44771525,14 3,14.4477153 3,15 C3,15.5522847 3.44771525,16 4,16 Z'
                                id='Line'
                            />
                            <path
                                d='M10,16 L12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 L10,14 C9.44771525,14 9,14.4477153 9,15 C9,15.5522847 9.44771525,16 10,16 Z'
                                id='Line-Copy'
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
